// src/features/profile/api/profile/read.js
import axiosInstance from '@/lib/axios';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');
  if (!token || !tokenType) throw new Error('Unauthorized. Please log in.');
  return {
    Authorization: `${tokenType} ${token}`,
  };
};

export async function readAdmin() {

  const response = await axiosInstance.get('/users/me', {
    headers: getAuthHeaders(),
  });
  return response.data;


}

export async function patchAdmin(formData) {



  const response = await axiosInstance.patch('/users/me', formData, {
    headers: getAuthHeaders(), // Axios handles multipart automatically
  });


  return response.data;

}

// ✅ Delete current admin/user
export async function deleteAdmin() {
  try {
    const response = await axiosInstance.delete('/users/me', {
      headers: getAuthHeaders(),
    });
    return response.status === 200;
  } catch (error) {
    throw error;
  }
}

export async function patchPassword({ oldPassword, newPassword, confirmPassword }) {
  try {
    const response = await axiosInstance.patch(
      '/users/me/password',
      {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_new_password: confirmPassword,
      },
      {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Password change failed: ${message}`);
  }
}









// ✅ Fetch all admin security questions
export async function fetchSecurityQuestions() {
  try {
    const response = await axiosInstance.get('/admin/security_questions', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Failed to fetch security questions: ${message}`);
  }
}

// ✅ Fetch current user's security questions
export async function fetchUsrSecurityQuestions() {
  try {
    const response = await axiosInstance.get('/users/users_security_questions', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      // User has no security questions yet
      return [];
    }
    console.error('Failed to fetch user security questions:', error);
    throw new Error('Failed to fetch user security questions.');
  }
}



export async function createUsrSecurityQuestions(data) {
  try {
    const response = await axiosInstance.post(
      '/users/users_security_questions',
      data,
      {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Failed to save security question: ${message}`);
  }
}




// ✅ Update user security questions
export async function patchUsrSecurityQuestions(data) {
  try {
    const response = await axiosInstance.patch(
      '/users/users_security_questions',
      data,
      {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Failed to save security question: ${message}`);
  }
}